<template>
  <div class="home-box fadeIn">
    <Introduction :currentStore="currentStore" v-if="currentStore"></Introduction>

    <div class="course">
      <div class="course-title">“中国经济学”规划教材</div>
      <a-input-search class="input-search" v-model:value="keyword" placeholder="请输入教材名称搜索" @search="onSearch" />

      <!-- <div class="catalog-box" v-if="catalogList.length > 1">
        <div class="catalog">
          <div class="catalog-item" :class="{ selected: catActive == i, noicon: !catalog.icon }"
            v-for="(catalog, i) of catalogList" @click="chooseCatalog(i)">
            <i class="catalog-icon" :style="{ backgroundImage: 'url(' + catalog.icon + ')' }" v-if="catalog.icon"></i>
            <span class="catalog-title">{{ catalog.name }}</span>
          </div>
        </div>
        <div class="catalog-page catalog-left" @click="catalogScroll('left')">
          <svg class="svg-icon">
            <use xlink:href="#icon-last" />
          </svg>
        </div>
        <div class="catalog-page catalog-right" @click="catalogScroll('right')">
          <svg class="svg-icon">
            <use xlink:href="#icon-next" />
          </svg>
        </div>
      </div> -->

      <div class="book-list-box">
        <div class="course-box">
          <BookItem :book="book" v-for="book of showBooks"></BookItem>
          <emptyBox warning="暂无此类教材" v-if="showBooks.length == 0"></emptyBox>
        </div>
      </div>

      <div class="course-bottom" v-if="storeBooks.length >= pageSize">
        <div class="pagination pagination-left" @click="changePage(page - 1)">
          <svg class="svg-icon">
            <use xlink:href="#icon-last" />
          </svg>
        </div>
        <div class="pagination pagination-center" @click="routerPath('all-course')"
          v-if="catalogList[catActive]?.id == ''">
          全部
        </div>

        <div class="pagination pagination-right" @click="changePage(page + 1)">
          <svg class="svg-icon">
            <use xlink:href="#icon-next" />
          </svg>
        </div>
      </div>
    </div>

    <Recommend :storeBooks="storeBooksRecommend" v-if="storeBooksRecommend.length > 0"></Recommend>
    <foot v-if="!phoneMode"></foot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import foot from "@/component/public/foot/foot.vue";
import navroot from "@/component/public/nav/nav.vue";
import emptyBox from "@/component/public/empty-box/empty-box.vue";
import BookItem from '@/component/BookItem.vue';
import Introduction from "./Introduction.vue";
import Recommend from "./Recommend.vue";
export default {
  name: "home",
  components: {
    navroot,
    foot,
    emptyBox,
    BookItem,
    Introduction,
    Recommend
  },
  data() {
    return {
      catalogList: [],
      catActive: 0,

      clounmBooks: ['b1ea2500-17e0-11ef-80e7-3d8d150c0749', '841c82aa-c689-414d-b9be-4e68801763e3', 'c23c17fc-ede2-441c-b757-ca1697be7c16', 'e5d9693c-98a5-4fe2-adca-9ce23208804f','94576793-8c53-4a33-b0c2-ebdc3a36aa8a', 'b7d78c3c-8f82-47be-b6b9-c83d75c44dd8'],
      allStoreBooks: [],
      storeBooks: [],
      storeBooksRecommend: [],
      showBooks: [],

      page: 1,
      pageSize: 10,
      maxPage: 1,
      needScroll: false,

      rdList: [],
      rdLast: null,
      rdSlideshow: 3000,
      rdActive: 0,
      rdInterval: null,

      pageTemplate: null,
      navContent: null,
      newOpenBook: null,
      keyword: "",

      vipPastdue: true,
      loadding: true,
      updateDgUser: false,

      currentStore: null,
    };
  },
  computed: {
    ...mapState({
      columns: (state) => state.columnList,
      userInfo: 'userInfo',
      phoneMode: 'phoneMode',
    })
  },
  async mounted() {
    const { id } = this.$route.params;
    const clounm = this.columns.find((item) => item.pk_digital_column_id == id);

    if (!clounm) return;

    const { store_id } = clounm.config;
    if (!store_id) {
      this.$message.error("该专栏未绑定教材商店");
      return;
    }

    this.currentStore = await this.$api.bookManage.storeFindOne(store_id).then(res => res.data)
    this.setPageTemplate();
    this.judgeCardMove();

    const content = document.getElementById('content');
    if (content) content.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.commit('showReturn', true);
  },
  methods: {
    //设置pageTemplate
    async setPageTemplate() {
      const { storeBooks } = this.$store.state;
      let allStoreBooks = JSON.parse(JSON.stringify(storeBooks));
      allStoreBooks = allStoreBooks.filter((item) => this.clounmBooks.includes(item.pk_store_book_id));
      this.storeBooksRecommend = allStoreBooks.filter((item) => item.is_recommend == 1);
      this.allStoreBooks = allStoreBooks;

      const typeGroups = this.currentStore.typeGroups;
      let catalogList = [{ name: "全部", id: "" }]
      if (typeGroups.length > 0) catalogList = [...catalogList, ...typeGroups[0].list];
      this.catalogList = catalogList;

      const rdList = allStoreBooks;
      this.rdLast = rdList[rdList.length - 1];
      this.rdList = rdList;

      this.catActive = 0;
      this.chooseCatalog(this.catActive);
    },

    ////////////////////////////////推荐轮播
    //选择推荐
    rdChoose(i, type) {
      let rdActive = this.rdActive;
      if ((i == rdActive && type != "dot") || this.phoneMode) {
        return this.routerInfo(this.rdList[i]);
      }

      let dom = this.$refs.recommended;
      if (!dom) return;
      dom.style.transitionDuration = `1s`;

      let item_dom = this.$refs[`rd_${i}`];
      if (item_dom > 0) item_dom[0].style.transition = `all .7s ease`;

      let old_item_dom = this.$refs[`rd_${rdActive}`];
      if (old_item_dom > 0) old_item_dom[0].style.transition = `all .7s ease`;

      //恢复
      setTimeout(() => {
        dom.style.transitionDuration = `.3s`;
        if (item_dom.length > 0) item_dom[0].style.transition = `all .3s ease`;
        if (old_item_dom > 0) old_item_dom[0].style.transition = `all .3s ease`;
      }, 1000);

      this.rdMove(i);
    },
    //选择占位
    rdHolder(i) {
      let rdActive = this.rdActive;
      if (i == rdActive) return;

      this.rdMove(i);
    },
    //rd鼠标移入移出
    rdMouse(type) {
      if (this.phoneMode) return;
      if (type == "enter") {
        window.addEventListener("mousewheel", this.rdMousewheel);
        $("body").css("overflow-y", "hidden");
        $("body").css("padding-right", "10px");
      } else {
        window.removeEventListener("mousewheel", this.rdMousewheel);
        $("body").css("overflow-y", "auto");
        $("body").css("padding-right", "0px");
      }
    },
    //监听鼠标滚轮
    rdMousewheel(e) {
      let direction = e.deltaY > 0 ? "down" : "up";
      let rdActive = this.rdActive;
      let rdList = this.rdList;

      if (direction == "down") {
        if (rdActive == rdList.length - 1) this.rdMove(0);
        else this.rdMove(rdActive + 1);
      } else if (direction == "up") {
        if (rdActive == 0) this.rdMove(rdList.length - 1);
        else this.rdMove(rdActive - 1);
      }
    },
    //轮播图移动
    rdMove(i) {
      if (this.rdInterval) clearInterval(this.rdInterval);

      this.rdActive = i;
      let dom = this.$refs.recommended;
      if (!dom) return;
      let left_ts = i ? i * 280 + 350 : 350;
      dom.style.transform = `translate3d(-${left_ts}px, 0px, 0px)`;

      this.rdAutoMove();
    },
    //轮播图自动滚动
    rdAutoMove() {
      this.$nextTick(() => {
        let rdActive = this.rdActive;
        let rdList = this.rdList;

        if (this.rdInterval) clearInterval(this.rdInterval);
        this.rdInterval = setInterval(() => {
          if (rdActive == rdList.length - 1) this.rdChoose(0, "");
          else this.rdChoose(rdActive + 1, "");
        }, this.rdSlideshow);
      })
    },
    ////////////////////////////////分类
    //选择分类
    chooseCatalog(i) {
      this.catActive = i;

      //关键词
      let storeBooks = this.allStoreBooks.filter((item) => item.name.indexOf(this.keyword) > -1);
      const catalog = this.catalogList[i];

      if (catalog.id) {
        storeBooks = storeBooks.filter((item) => item.types.indexOf(catalog.id) > -1);
      }

      this.storeBooks = storeBooks;
      this.maxPage = Math.ceil(this.storeBooks.length / this.pageSize);

      this.needScroll = false;
      this.changePage(1);

      this.loadding = false;
    },
    //翻页
    changePage(page) {
      if (page <= 0) return this.$message.warning("已经是第一页了");
      else if (page > 1 && page > this.maxPage) return this.$message.warning("已经是最后一页了");
      this.page = page;

      let pageSize = this.pageSize;
      let storeBooks = JSON.parse(JSON.stringify(this.storeBooks));
      this.showBooks = storeBooks.slice((page - 1) * pageSize, page * pageSize);
      this.page = page;

      if (this.needScroll) {
        if (this.phoneMode) {
          $("body").animate({ scrollTop: 450 }, 300);
        } else {
          $("body").animate({ scrollTop: 870 }, 300);
        }
      }
      this.needScroll = true;
    },
    //滚动条移动
    catalogScroll(type) {
      let scroll = $(".catalog").scrollLeft();
      if (type == "left")
        $(".catalog").animate({ scrollLeft: scroll - 700 }, 300);
      else if (type == "right")
        $(".catalog").animate({ scrollLeft: scroll + 700 }, 300);
    },

    //跳转
    routerCourse(item) {
      const { isPaid } = item;
      if (isPaid) {
        this.routerStudy(item);
      }
      else {
        this.routerInfo(item);
      }
    },
    //跳转详情
    routerInfo(item) {
      const { storeUrl, isOtherStore } = item;

      const url = `course-info/${item.pk_store_book_id}`
      if (isOtherStore) {
        if (!this.userInfo) this.$router.push({ path: 'login' });
        else window.open(`${storeUrl}/${url}`);
      }
      else {
        $("body").css("overflow-y", "auto");
        $("body").css("padding-right", "0px");
        this.$router.push({ path: `course-info/${item.pk_store_book_id}` });
      }
    },
    //学习
    routerStudy(item) {
      const { pk_store_book_id, system_id, single_url, storeUrl, isOtherStore } = item;
      let url = `/bookReader/${pk_store_book_id}`;
      if (single_url) {
        url = `${single_url}?pk_store_book_id=${pk_store_book_id}&system_id=${system_id}`;
      }

      if (isOtherStore) {
        url = `${storeUrl}${url}`
      }
      window.open(url)
    },


    //关键词搜索
    onSearch() {
      this.chooseCatalog(this.catActive);
    },
    //跳转
    routerPath(url) {
      this.$router.push({ path: url });
    },
    //////////////////////////////卡片轮播
    //判断初始card位移
    judgeCardMove() {
      this.cardTransform = 1150 - window.innerWidth / 2;

      setTimeout(() => {
        this.cardMove(0);
      }, 1000);

      let that = this;
      $(window).resize(function () {
        that.cardTransform = 1150 - window.innerWidth / 2;
        that.cardMove(that.cardActive);
      });
    },
    //选择卡片
    cardChoose(i) {
      if (this.phoneMode) return;

      let cardActive = this.cardActive;
      if (i == cardActive) return;

      let dom = this.$refs.card;
      if (!dom) return;
      dom.style.transitionDuration = `.3s`;
      //恢复
      setTimeout(() => {
        dom.style.transitionDuration = `0s`;
      }, 400);

      this.cardMove(i);
    },
    //选择占位
    holderCard(i) {
      let cardActive = this.cardActive;
      if (i == cardActive) return;

      this.cardMove(i);
    },
    //轮播图移动
    cardMove(i) {
      this.cardActive = i;
      let dom = this.$refs.card;
      let ctf = this.cardTransform;
      if (!dom) return;

      let left_ts = 0 - (i * 440 + ctf + 20);
      dom.style.transform = `translate3d(${left_ts}px, 0px, 0px)`;
    },
  },
  beforeDestroy() {
    //去除轮训
    if (this.rdInterval) clearInterval(this.rdInterval);
    if (this.columnInterval) clearInterval(this.columnInterval);
  },
};
</script>

<style lang="scss" scoped>
.home-box {
  padding-top: 100px;
}

.course {
  text-align: center;
  margin: 80px 0;

  .course-title {
    font-size: 30px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 10px;
  }

  .input-search {
    box-shadow: 1px 1px 2px #333333af, // 右下方的阴影
  }

  .catalog-box {
    height: 140px;
    display: flex;
    align-items: center;
    position: relative;

    .all-course {
      background-color: var(--primary-color);
      height: 50px;
      border-radius: 7px;
      border: none;
      margin-right: 10px;
    }

    .catalog {
      display: flex;
      align-items: center;
      overflow-y: hidden;
      white-space: nowrap;
      position: absolute;
      left: 100px;
      width: calc(100% - 200px);
      height: 100px;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }

      .catalog-item {
        padding: 2px 20px;
        background-color: var(--background-opacity);
        margin: 0 10px;
        font-size: 17px;
        height: 50px;
        display: flex;
        align-items: center;
        border-radius: 7px;
        transition: all .3s ease;
        cursor: pointer;
        position: relative;

        &.selected {
          background-color: var(--primary-color);

          .catalog-icon {
            opacity: 1;
            height: 60px;
            width: 60px;
          }

          .catalog-title {
            padding-left: 70px;
          }
        }

        &.noicon {
          .catalog-title {
            padding-left: 0;
          }
        }

        .catalog-icon {
          height: 40px;
          width: 40px;
          opacity: 0.5;
          transition: all .3s ease;
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

        .catalog-title {
          padding-left: 50px;
        }
      }
    }

    .catalog-page {
      position: absolute;
      background-color: var(--background-opacity);
      width: 40px;
      height: 40px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      cursor: pointer;
      transition: all .3s ease;

      &.catalog-left {
        left: 30px;
      }

      &.catalog-right {
        right: 30px;
      }

      &:hover {
        background-color: var(--primary-color);
        ;
      }
    }
  }

  .book-list-box {
    width: 100%;
    padding: 10px 0;
    margin: 40px 0;
    background: var(--background-opacity-top);
  }

  .course-box {
    margin: 0 auto;
    max-width: 1340px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;

    .course-item-box {
      margin: 50px 20px;
      width: calc(100%/5 - 40px);

      @media screen and (max-width: 1000px) {
        & {
          width: calc(100%/4 - 40px);
        }
      }

      @media screen and (max-width: 800px) {
        & {
          width: calc(100%/3 - 40px);
        }
      }

      .course-item {
        width: 100%;
        padding-bottom: 150%;
        cursor: pointer;
        transition: all .3s ease;
        text-align: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 5px;
        position: relative;
        transition: all .3s ease;
        color: #fff;
        box-shadow: var(--box-shadow);

        &:hover {
          transform: translateY(-15px);
          -webkit-transform: translateY(-15px);

          .course-top {
            .svg-box {
              opacity: 1;
            }
          }

          .course-bottom {
            .join-class {
              opacity: 1;
            }
          }
        }

        &.hide {
          display: none;
        }

        .svg-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: #bfbfbf94;
          transition: all .3s ease;

          &:hover {
            background-color: var(--primary-color);
          }

          .icon-svg {
            font-size: 20px;
          }
        }

        .course-top {
          top: 0;
          left: 0;
          width: 100%;
          padding: 10px 15px;
          position: absolute;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .has-buy {
            padding: 0px 7px;
            margin-right: auto;
            font-size: 12px;
            border-radius: 10px;
            background-color: var(--primary-color);
          }

          .svg-box {
            margin-left: 5px;
            opacity: 0;
          }
        }

        .course-bottom {
          z-index: 1;
          bottom: 0;
          left: 0;
          padding: 5px 15px;
          height: 42px;
          width: 100%;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .book-tag {
            padding: 2px 10px;
            color: #ffffff;
            background-color: #7e7b7b80;
            border-radius: 15px;
            font-size: 12px;
            margin-right: auto;
          }

          .join-class {
            opacity: 0;
            display: flex;
            align-items: center;
            transition: all .3s ease;

            &.joined {
              opacity: 1;
            }
          }

          .course-status {
            margin-left: auto;

            &.hide {
              opacity: 0;
              width: 0;
            }

            >div {
              display: flex;
              align-items: center;
              padding: 2px 8px;
              border-radius: 16px;
              background-color: #333333b8;
              font-size: 14px;

              svg {
                font-size: 20px;
                margin-right: 5px;
              }
            }
          }
        }
      }

      .course-info {
        margin-top: 10px;
        font-size: 14px;

        .course-name {
          font-size: 17px;
          ;
        }

        .course-sub-name {
          color: #aaa;
        }

        .course-price {
          color: var(--primary-color);
        }
      }
    }
  }

  .course-bottom {
    position: relative;
    width: 160px;
    height: 50px;
    margin: 0 auto;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-between;


    .pagination {
      background-color: var(--background-opacity);
      width: 40px;
      height: 40px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      cursor: pointer;
      transition: all .3s ease;
      top: 0;

      &.pagination-center {
        position: relative;
        margin: 0 auto;
        font-size: 14px;
        width: 50px;
        height: 50px;
      }

      &.pagination-left {
        left: 30px;
      }

      &.pagination-right {
        right: 30px;
      }

      &:hover {
        background-color: var(--primary-color);
        ;
      }
    }
  }
}

.portraits-box {
  background-color: #ffffffeb;

  .box-content {
    width: 100%;
    max-width: 100%;
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}


//手机端
#content {
  &.phone-mode {
    .home-box {
      .course {
        margin-bottom: 50px;

        .course-title {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .catalog-box {
          margin-top: 10px;
          height: 70px;

          .catalog {
            width: 100%;
            left: 0;
            padding: 0 5px;
            margin: 20px 0;
            height: 40px;
            background-color: #ffffff2e;

            .catalog-item {
              background-color: #ffffff00 !important;
              font-size: 16px;
              padding: 0;
              height: auto;

              .catalog-title {
                padding-left: 0;
              }

              .catalog-icon {
                display: none;
              }
            }
          }

          .catalog-page {
            display: none;
          }
        }

        .course-box {
          margin: 20px 10px;
          width: calc(100% - 20px);

          .course-item-box {
            width: calc(100%/2 - 20px);
            margin: 30px 10px;

            .course-item {
              transform: none;

              .course-top {
                padding: 5px 8px;

                .svg-box {
                  opacity: 1;
                }
              }

              .course-bottom {
                padding: 0px 8px;
                height: 30px;

                .join-class {
                  opacity: 1;
                }
              }
            }

            .course-info {
              font-size: 12px;

              .course-name {
                font-size: 15px;
              }
            }
          }
        }

        .course-bottom {
          .pagination {
            &:hover {
              background-color: var(--background-opacity);
            }
          }
        }
      }

      .column-box {
        padding: 0;

        .column-title {
          width: calc(100% - 10px);
        }

        .column {
          &::-webkit-scrollbar {
            width: 0;
            height: 0;
          }

          .column-list {
            .column-item {
              .column-cover {
                &::before {
                  background-color: rgba(0, 0, 0, 0);
                }
              }
            }
          }
        }
      }


      .card-box {
        .card-title {
          width: calc(100% - 10px);
        }

        .card {
          height: auto;
          padding-top: 30px;

          .card-list {
            transform: none !important;
            padding: 0 10px;
            position: relative;

            .card-item {
              margin: 0px 10px;
              min-width: 250px;
              height: 425px;
              padding-top: 190px;
              opacity: 1;

              .card-cover {
                height: 170px;
                width: 100%;
                margin-top: 20px;
                background-size: contain;
              }

              .card-content {
                font-size: 14px;
              }
            }
          }
        }
      }
    }

    .home-info {
      width: 100%;
      text-align: center;
      padding: 0 20px;


      .info-text {
        width: 100%;
      }

      .info-img {
        display: none;
      }
    }
  }
}
</style>
